import { render, staticRenderFns } from "./ShowPercepcionMaternidadDown.vue?vue&type=template&id=73bea4e8&scoped=true&"
import script from "./ShowPercepcionMaternidadDown.vue?vue&type=script&lang=js&"
export * from "./ShowPercepcionMaternidadDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bea4e8",
  null
  
)

export default component.exports